var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMuteVideoEveryoneElse = function SvgMuteVideoEveryoneElse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m3.136 7.1 14.448 14.447-1.033 1.032-2.598-2.599a.94.94 0 0 1-.459.153H3.709a.786.786 0 0 1-.803-.804V11.15c0-.459.344-.803.803-.803h.612L2.104 8.131zm14.448 3.669v8.714l-9.135-9.134h5.045c.459 0 .84.344.84.803v2.866zM14.688.818l8.164 8.165-.584.583L20.8 8.098a.54.54 0 0 1-.26.086h-5.528a.444.444 0 0 1-.454-.454V3.108c0-.26.195-.454.454-.454h.345l-1.253-1.253zm8.164 2.074v4.924L17.69 2.654h2.851c.26 0 .476.194.476.454v1.619z"
  })));
};
export default SvgMuteVideoEveryoneElse;